import EcosiaUser from '@ecosia/ecosia-user';
import {
  HEIMDALL as HEIMDALL_COOKIE,
  LOGIN_BETA as LOGIN_BETA_COOKIE,
  MAIN as MAIN_COOKIE,
} from '~~/common/js/constants/cookies';
import { getCookieOptions, getHeimdallCookieDomain } from '~~/common/js/universal/utils';
import { getPersonalCounter, refreshToken } from '~~/common/js/client/api';

export default {
  data() {
    return {
      personalCounterFetched: false,
    };
  },
  methods: {
    refreshBetaCookie() {
      // The linter fails with the message
      // location.hostname() is not supported in Opera 71 compat/compat
      // But CanIUse is giving green for this feature:
      // https://caniuse.com/?search=window.location.hostname
      // eslint-disable-next-line compat/compat
      const domain = window.location.hostname;
      const oneYearFuture = new Date();
      oneYearFuture.setFullYear(oneYearFuture.getFullYear() + 1);
      this.$cookies.set(
        LOGIN_BETA_COOKIE,
        true,
        getCookieOptions({ domain, expires: oneYearFuture }),
      );
    },
    initHeimdallLogin() {
      const token = this.$cookies.get(HEIMDALL_COOKIE);

      if (!token) {
        this.personalCounterFetched = true;
        return;
      }

      getPersonalCounter(token)
        .then((data) => {
          if (!data.error) {
            this.$store.commit('user/setTreeCount', data.personal_counter);
            this.$store.commit('user/setLoggedIn', true);

            const cookieString = this.$cookies.get(MAIN_COOKIE);
            const user = new EcosiaUser({ cookieString });
            user.set('treeCount', data.personal_counter);
          }
        })
        .finally(() => {
          this.personalCounterFetched = true;
          // We currently use the ECBT Cookie to indicate that
          // a user has already logged in from a device
          // The cookie expire date needs to be updated to ensure it
          // will not be deleted after 31 days
          this.refreshBetaCookie();
        });

      refreshToken(token)
        .then((data) => {
          if (!data.error) {
            if (data.token.value !== token) {
              const { hostname } = window.location;
              const domain = getHeimdallCookieDomain(window.location.hostname);

              const options = getCookieOptions({ domain, expires: new Date(data.token.expiry) });

              if (hostname !== 'localhost' && hostname !== 'local.ecosia.org') {
                options.secure = true;
                options.sameSite = 'strict';
              }

              this.$cookies.set(
                HEIMDALL_COOKIE,
                data.token.value,
                options,
              );
            }
          }
        });
    },
  },
};
